import {
  getNewsContent,
  activeNewsReadCount,
  getNewsArticles,
  getMiniQrCode,
  getActivityList
} from '@/api'
import share from '@/mixins/share-finder.js'
import {formatTime} from '@/filters/index.js'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapState: mapArticleState } = createNamespacedHelpers('article')
import { mapState, mapMutations } from 'vuex'
import photoSwipe from '@/mixins/photoSwipe.js'
import url from 'url'
import {getStorage, removeStorage} from '@/utils/storage.js'
import { queryTemplateConfigInfoApi } from '../../api/services/launcher-user'

let query = url.parse(window.location.toString(), true).query

let playStartTime = Date.now()

export default {
  name: 'articles',
  mixins: [share, photoSwipe],
  data() {
    return {
      articleInfo: {
      },
      article: {
        title: ''
      },
      isShowComment: false,
      isRender: true,
      timer: null,
      columnCode: '',
      columnName: '图文消息',
      showActivity:false,
      activityInfo: {},
      showMask: false,
      miniprogramPic: '',
      enterTime: 0, //文章详情进入时间
      isOver: false,
      urlList: {
        'wechat.jfql': 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU5NDY5MzM0Ng==&scene=116#wechat_redirect',
        'wechat.htz': 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU3Mzg5MjMzNw==&scene=116#wechat_redirect'
      }
    }
  },
  filters: {
    formatTime
  },
  computed: {
    ...mapGetters(['cacheArticleHtml']),
    ...mapArticleState(['cacheArticle']),
    ...mapState(['wechatUser', 'serviceConfig','investId']),
    title() {
      let urlTitle = this.serviceConfig.projectName
      if (urlTitle) {
        return urlTitle
      }
      return ''
    },
    isCanGoGZH () { // 是否可以跳转公众号
      let a = ['wechat.jfql', 'wechat.htz']
      return a.includes(this.serviceConfig.appCode) || false
    }
  },
  components:{
    Comment: () => import('@/components/launcher-comment/index.vue'),
    PhotoSwipe: () => import('@/components/PhotoSwipe.vue')
  },
  async created() {
    this.setDocumentTitle(this.title)
    this.enterTime = Date.now()
    this.isRender = true
    if(this.cacheArticleHtml) {
      this.articleInfo = this.cacheArticle
    } else {
      const type = this.$route.params.type
      if(type.length === 32) {
        this.columnCode = this.$route.query.columnName || ''
        await this.getArticleInfo(type)
      } else {
        this.columnCode = type
        await this.getNewsArticles(type)
      }
    }
    this.isRender = false
    this.$nextTick(()=>{
      console.log('userAgent',window.navigator.userAgent,!!window.navigator.userAgent.match(/MicroMessenger/gi))
        const a = document.getElementsByClassName("linkA");
        a && Array.prototype.forEach.call(a,item=>{
          if(item.getAttribute("h5")==='javascript:void(0)'){
            //无效链接禁止打开窗口
            item.setAttribute('target','_self')
          }
          item.setAttribute('href',item.getAttribute("h5"))
          console.log('a',item,item.getAttribute("h5"))
        })
    })
    
    let query = url.parse(window.location.toString(), true).query
    let {key = '', brokerCode = '', brokerName = '', shareFromUnionId = '', columnName, click_type = ''} = query

    if (key === 'wechat-common-htz') { // 慧投资公众号
      if (this.articleInfo.newsId === '76962bccb72fe1e86be7d55d03a160a5') { // 生产【下载慧投资app】
        this.$sa.track('enter_downloadpage')
      }
    }

    this.$sa.track('view_the_article', {
      column_id: this.columnCode,
      column_name: this.columnName,
      news_id: this.articleInfo && this.articleInfo.newsId || '',
      news_title: this.articleInfo && this.articleInfo.title || '',
      publisher_id: this.articleInfo.author && this.articleInfo.author.id || '',
      publisher_name: this.articleInfo.author && this.articleInfo.author.name || '',
      adviser_id: brokerCode,
      adviser_name: brokerName,
      pre_union_id: shareFromUnionId,
      article_url: location.href,
      page_source: this.$route.query.page_source || query.page_source,
      click_type
    })

    // 获取订阅模板数据的方法
    await this.getAndSetTemplateConfigInfo(columnName)
  },
  mounted() {
    let {key = ''} = query
    setTimeout(() => {
      if((key === 'wechat-common-tthj' || key === 'wechat-common-ttj') && getStorage('INVEST_ID')) {
        this.getActivityPic()
        this.getMiniQrCode(getStorage('INVEST_ID'))
      }
    },2000);

    this.timer = setInterval(() => {
      const iframe =window.document.querySelector('.iframe')
      this.initMedia(iframe)
      this.handleImageClick()
    }, 1000)

    this.$nextTick(() => {
      window.addEventListener('scroll', (e) => {
        let dom = e.srcElement || e.target
        if (this.isOver) return
        const {clientHeight, scrollHeight, scrollTop} = dom
        if (scrollTop >= scrollHeight - clientHeight) {
          let {brokerCode = '', brokerName = '', shareFromUnionId = ''} = query
          this.isOver = true
          let data = {
            column_id: this.columnCode,
            column_name: this.columnName,
            is_not_free: false,
            news_id: this.articleInfo && this.articleInfo.newsId || '',
            news_title: this.articleInfo && this.articleInfo.title || '',
            publisher_id: this.articleInfo.author && this.articleInfo.author.id || '',
            publisher_name: this.articleInfo.author && this.articleInfo.author.name || '',
            adviser_id: brokerCode,
            adviser_name: brokerName,
            pre_union_id: shareFromUnionId,
            article_url: location.href,
            page_source: this.$route.query.page_source || query.page_source
          }
          this.$sa.track('hit_article_bottom', data)
        }
      }, true)
    })
    this.$nextTick(()=>{
      
    })
  },
  destroyed: function () {
    clearInterval(this.timer)
  },
  beforeDestroy() {
    // 离开文章详情 神策打点
    let endTime = Date.now()
    let query = url.parse(window.location.toString(), true).query
    let {source = '', brokerCode = '', brokerName = ''} = query
    let data = {
      source: source || 'push',
      news_id: this.articleInfo.newsId || '',
      title: this.articleInfo.title || '',
      adviser_id: brokerCode,
      adviser_name: brokerName,
      staytime: Math.floor((endTime - this.enterTime)/1000),
      page_source: this.$route.query.page_source || query.page_source
    }
    this.$sa.track('exit_article_detail', data)
  },
  methods: {
    ...mapMutations(['SET_SERVICE_CONFIG']),
    // 跳转公众号
    goGZH (serviceConfig) {
      if (!this.isCanGoGZH) return
      let _url = this.urlList[serviceConfig.appCode] || ''
      location.href = _url
    },
    setDocumentTitle(title) {
      document.title = title
      let i = document.createElement('iframe')
      i.style.display = 'none'
      i.onload = function () {
        setTimeout(() => {
          i.remove()
        }, 0)
      }
      document.body.appendChild(i)
    },
    closeActivity(){
      this.showActivity = false
    },
    async getActivityPic () {
      let params = {
        activityType:'MARKETING',
        applicationCode:'com.rjhy.venus',
        position:'tthj.xcx.wz.icon',
        hiddenStatus:'SHOWN',
        activityStatus:'NOW'
      }
      const res = await getActivityList(params)
      console.log(res)
      if(res&&res.code === 0 && res.data.list.length) {
        this.activityInfo = res.data.list[0]
        this.showActivity = true
      }
    },
    hideMask () {
      this.showMask = false
    },
    ToShowMask () {
      this.showMask = true
    },
    async getMiniQrCode (scene) {
      const env = process.env.VUE_APP_WEB || 'local'
      const originId = {
        'local': 'gh_1d02287d1815',
        'production': 'gh_2f65b828b5bc'
      }[env]

      // 小程序码只有生产可测试，直接用生产的originId
      let params = {
        originId,
        page: 'pages/home/index',
        scene
      }
      const res = await getMiniQrCode(params)
      if(res.data.code === 0){
        this.miniprogramPic = `data:image/png;base64,${res.data.result}`
        removeStorage('INVEST_ID')
      }
    },
    initMedia(iframe) {
      if(!iframe) return;
      clearInterval(this.timer)
      if(this.$route.query.isScroll) this.scrollToComment()
      this.handleAudio()
      this.handleVideo()
      this.handleAudioDeprecated()
      this.hideImg()
      this.adaptStyle()
      this.isShowComment = true
    },
    async getNewsArticles(type) {
      const {data: {code, data}} = await getNewsArticles(type, this.serviceConfig.appCode)
      if(code !== 1) return this.$message('服务报错');
      if(data.length === 0) return;
      let newsId = data[0].newsList[0] && data[0].newsList[0].newsId
      await this.getArticleInfo(newsId)
    },
    async getArticleInfo(articleId) {
      const {data: {code, data}} = await getNewsContent(articleId, this.serviceConfig.appCode)
      if(code !== 1) return this.$message('服务报错');
      if(data && data.content) {
        activeNewsReadCount(data.newsId, this.serviceConfig.appCode)
        data.content = data.content.replace(/(\<em\ id\=\"publish_time\"\ class\=\"rich_media_meta\ rich_media_meta_text\"\>).*?(\<\/em\>)/, function() {
          return `<em id="publish_time" class="rich_media_meta rich_media_meta_text">${formatTime(data.publishTime, 'yyyy-mm-dd')}</em>`
        })
        data.content = data.content.replace(/<[^video][^<>]*?>/gi, match => {
          return match.replace(/width="\d+"/gi, '')
        })
        data.content = data.content.replace(/[^-]width\:(.+?)px/gi, (match, p1) => {
          const clientWidth = document.getElementById('app').clientWidth
          if (Number(p1) > clientWidth) {
            return 'width: 100%'
          }
          return match
        })
        if (data.content.indexOf('<section style="font-size:16px;padding:20px 16px 12px;">') === -1) {
          data.content = `<section style="font-size:16px;padding:20px 16px 12px;">${data.content}</section>`
        }
      } else {
        data.content = undefined
      }
      this.articleInfo = data
      this.$store.dispatch('article/set_cache_article', data)
      if(this.articleInfo) {
        const column = this.articleInfo.columnBeans.find(i => i.code === this.columnCode)
        this.columnName = (column && column.name) || this.columnName
        // let columnCode = this.$route.query.columnCode || this.articleInfo.columnBeans.map(i => i.code).join(',')
        this.articleInfo.columnName = this.columnName
        let type = ''
        if(this.articleInfo.dataType === 3) {
          type = 'article'
        }
        if(this.articleInfo.dataType === 4) {
          type = 'video'
        }
        this.$store.dispatch('set_share_info', {
          name: this.serviceConfig.projectName,
          newsId: data.newsId,
          title: data.title,
          desc: data.introduction,
          imgUrl: data.attribute.listImageUrl,
          articleType: type,
          columnId: this.columnCode,
          columnName: this.articleInfo.columnName,
          cb: this.onMenuShare,
        })
      }
    },
    scrollToComment() {
      const article = document.querySelector('.article')
      const iframe = window.document.querySelector('.iframe')
      const comment = window.document.querySelector('.comment')
      const header = comment.querySelector('.header')
      let timer = setTimeout(() => {
        article.scrollTop = iframe.offsetHeight + header.offsetHeight/2
        clearTimeout(timer)
      },2000)
    },
    handleAudio() {
      let _this = this
      const audioControllers = [].slice.call(document.querySelectorAll('.share_audio_context'))
      if (!audioControllers.length) return
      audioControllers.map(v => {
        formatAudio(v)
      })
      function formatAudio(audioController) {
        const share_audio_length_total = audioController.querySelector(".share_audio_length_total")
        if(!audioController) return;
        const progress = audioController.querySelector('.share_audio_progress_inner')
        const currentTime = audioController.querySelector('.share_audio_length_current')
        let timer
        if (!audioController) return

        const audio = audioController.querySelector('audio')
        audio.load()
        audio.oncanplay = function () {
          share_audio_length_total.innerHTML = _this.formatTime(audio.duration)
        }
        const reset = () => {
          clearTimeout(timer)
          audio.currentTime = 0
          currentTime.textContent = _this.formatTime(0)
          progress.style.width = 0
          audioController.classList.remove('share_audio_playing')
        }

        audio.addEventListener('ended', () => {
          reset()
          _this.$sa.track('finish_audio', {
            current_page_type: 'artical_detail_page',
            page_title: 'artical_detail_page',
            news_id: _this.articleInfo.newsId,
            news_title: _this.articleInfo.title,
            audio_url: audio.src,
            finish_type: 'finish',
            page_source: _this.$route.query.page_source || query.page_source,
            staytime: Math.floor((Date.now() - playStartTime) / 1000) || 0,
            progress_bar_position: Math.floor(audio.currentTime)
          })
        })

        audioController.addEventListener('click', () => {
          if (audio.paused) {
            audio.play()
            playStartTime = Date.now()
            audioController.classList.add('share_audio_playing')
            timer = setInterval(() => {
              currentTime.textContent = _this.formatTime(audio.currentTime)
              progress.style.width = audio.currentTime / audio.duration * 100 + '%'
            }, 1000)
            _this.$sa.track('play_audio', {
              current_page_type: 'artical_detail_page',
              page_title: 'artical_detail_page',
              news_id: _this.articleInfo.newsId,
              news_title: _this.articleInfo.title,
              audio_url: audio.src,
              page_source: _this.$route.query.page_source || query.page_source
            })
          } else {
            audio.pause()
            _this.$sa.track('finish_audio', {
              current_page_type: 'artical_detail_page',
              page_title: 'artical_detail_page',
              news_id: _this.articleInfo.newsId,
              news_title: _this.articleInfo.title,
              audio_url: audio.src,
              finish_type: 'pause',
              page_source: _this.$route.query.page_source || query.page_source,
              staytime: Math.floor((Date.now() - playStartTime) / 1000) || 0,
              progress_bar_position: Math.floor(audio.currentTime)
            })
            reset()
          }
        })
      }
    },
    handleVideo() {
      let _this = this
      const videoFrames = [].slice.call(document.querySelectorAll('.editor-video-content'))
      if (!videoFrames.length) return
      videoFrames.map(v => {
        resizeVideo(v)
      })
      function resizeVideo(videoFrame) {
        const aspectRatio = videoFrame.height / videoFrame.width
        videoFrame.height = videoFrame.clientWidth * aspectRatio
        videoFrame.style.height = videoFrame.height + "px"
        videoFrame.style.display = 'block'
        videoFrame.style.margin = '0 auto'
        videoFrame.addEventListener('play', () => {
          playStartTime = Date.now()
          _this.$sa.track('play_video', {
            current_page_type: 'artical_detail_page',
            news_id: _this.articleInfo.newsId,
            news_title: _this.articleInfo.title,
            page_source: _this.$route.query.page_source || query.page_source
          })
        })
        videoFrame.addEventListener('pause', () => {
          _this.$sa.track('finish_video', {
            current_page_type: 'artical_detail_page',
            finish_type: 'pause',
            news_id: _this.articleInfo.newsId,
            news_title: _this.articleInfo.title,
            page_source: _this.$route.query.page_source || query.page_source,
            exit_video_staytime: Math.floor((Date.now() - playStartTime) / 1000) || 0,
            progress_bar_position:  Math.floor(videoFrame.currentTime)// 暂停 停止的currentTime
          })
        })
        videoFrame.addEventListener('ended', () => {
          _this.$sa.track('finish_video', {
            current_page_type: 'artical_detail_page',
            finish_type: 'finish',
            news_id: _this.articleInfo.newsId,
            news_title: _this.articleInfo.title,
            page_source: _this.$route.query.page_source || query.page_source,
            exit_video_staytime: Math.floor((Date.now() - playStartTime) / 1000) || 0,
            progress_bar_position:  Math.floor(videoFrame.currentTime)// 暂停 停止的currentTime
          })
        })
      }
    },
    handleAudioDeprecated() {
      const audioController = document.querySelector('mpvoice+span')
      if (!audioController) return
      const audio = document.createElement('audio')
      const mediaid = audioController.id.replace(/^voice_main_(.*?)_0$/, (total, main) => main)
      audio.src = 'https://res.wx.qq.com/voice/getvoice?mediaid=' + mediaid
      audio.style.cssText = 'height:0;width:0;display:none'
      document.body.appendChild(audio)
      audioController.addEventListener('click', function () {
        if (audio.paused) {
          audio.play()
          audioController.classList.add('playing')
        } else {
          audio.pause()
          audioController.classList.remove('playing')
        }
      })
    },
    hideImg(){
      const img_loadings = document.querySelectorAll('.img_loading')
      const l = img_loadings.length
      for(let x = 0; x < l;x ++) {
        img_loadings[x].removeAttribute('data-src')
      }
    },
    adaptStyle() {
      const imgController = document.querySelectorAll('img')
          , aController = document.querySelectorAll('a')
      for(let x of imgController) {
        const imgStyle = x.style
        imgStyle.maxWidth = '100%'
        imgStyle.height = 'auto'
      }
      for(let x of aController) {
        x.style.color = 'grey'
      }
    },
    formatTime (value) {
      const val = Math.round(value)
      let min = Math.floor(val / 60)
      if (min < 10) {
        min = '0' + min
      }
      let sec = val % 60
      if (sec < 10) {
        sec = '0' + sec
      }
      return `${min}:${sec}`
    },
    browser() {
      return {
        versions:function(){
            var u = navigator.userAgent
            return {
                trident: u.indexOf('Trident') > -1, //IE内核
                presto: u.indexOf('Presto') > -1, //opera内核
                webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
                gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
                mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
                ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
                android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
                iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
                iPad: u.indexOf('iPad') > -1, //是否iPad
                webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
                weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
                qq: u.match(/\sQQ/i) == " qq" //是否QQ
            };
        }(),
        language:(navigator.browserLanguage || navigator.language).toLowerCase()
      }
    },
    formatSubscribeHtml(src) {
      return `<img class="subscribe-image" src="${src || 'https://upload.chongnengjihua.com/production/lib/images/subscribe.gif'}"/>`
    },
    // 获取模板及按钮信息并更新到serviceConfig中
    async getAndSetTemplateConfigInfo(columnCode) {
      // 图片存在则不需要重新拉取
      if (this.serviceConfig.button) return
      const params = {
        columnCode: columnCode || this.$route.query.columnName,
        originId: this.serviceConfig.originId
      }
      const res = await queryTemplateConfigInfoApi(params)
      if (res.code === 1 && res.data && res.data.templateId) {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: res.data.templateId,
          button: res.data.button
        })
      } else {
        this.SET_SERVICE_CONFIG({
          ...this.serviceConfig,
          subscribeTemplate: '',
          button: ''
        })
      }
    }
  }
}
